import './styles.scss';

document.addEventListener('DOMContentLoaded', function () {
  const imageContainers = document.querySelectorAll('.gallery__item',);
  
  imageContainers.forEach((container,) => {
    container.addEventListener('click', function () {
      const img = this.querySelector('img',);
      
      const expandedContainer = document.createElement('div',);
      expandedContainer.classList.add('expanded',);
      const expandedImg = document.createElement('img',);
      expandedImg.src = img.src;
      expandedImg.alt = img.alt;
      expandedContainer.appendChild(expandedImg,);

      // or esc key
      document.addEventListener('keydown', function (e,) {
        if (e.key === 'Escape') {
          expandedContainer.classList.remove('show',);
          // delete expandedContainer from DOm after transition
          setTimeout(() => expandedContainer.remove(), 300,); // Delay removal after transition
        }
      },);
            
      expandedContainer.addEventListener('click', function () {
        this.classList.remove('show',);
        setTimeout(() => this.remove(), 300,); // Delay removal after transition
      },);
      
      document.body.appendChild(expandedContainer,);
      setTimeout(() => expandedContainer.classList.add('show',), 50,); // Delay showing after adding to DOM
    },);
  },);
},);


// add swiper
import 'swiper/swiper-bundle.min.css';
import Swiper, { Navigation, Pagination, } from 'swiper';
Swiper.use([Pagination, Navigation,],);

new Swiper('.gallery-swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
},);
